export default __webpack_public_path__ + "static/media/SideBar.63a01f9e.svg";